<template>
  <AppModal
    v-model="showModal"
    centered
    class="app-info-modal"
    footer-centered
    :hide-footer="false"
    :title="title"
    @hide="$emit('hide')"
    @hidden="$emit('hidden')"
    @save="$emit('save')"
    @show="$emit('show')"
    @shown="$emit('hidden')"
  >
    <template #default>
      <div class="body">
        <slot name="default" />
      </div>
    </template>
    <template #footer-action-submit>Okay</template>
  </AppModal>
</template>

<script>
import AppModal from '@/components/modals/AppModal.vue';

export default {
  components: { AppModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  watch: {
    showModal(value) {
      this.$emit('input', value);
    },
    value(val) {
      this.showModal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-info-modal {
  .body {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.08em;
    color: vars.$c-dark-gray;

    ::v-deep p {
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.app-modal-wrapper {
    ::v-deep {
      .app-modal-body {
        padding-bottom: 32px;
      }
    }
  }
}
</style>
